import React from 'react';
export const MentaleGesundheitPage: React.FC = () => {
  return <>
      <section className="w-full bg-white py-16 px-6 md:px-12 lg:px-20" data-id="element-540">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-541">
          <div data-id="element-542">
            <h1 className="text-3xl md:text-4xl text-orange-500 font-light mb-6" data-id="element-543">
              Nur wer mental gesund ist, kann sein Potenzial voll ausschöpfen.
            </h1>
          </div>
          <div className="flex justify-center" data-id="element-544">
            <img src="https://cdn.magicpatterns.com/uploads/9QPaAAr3YE2Z5sTQeBKCX8/Eva-Schifferer-Coaching-Mentale_Gesundheit.png" alt="Mentale Gesundheit" className="max-h-80 object-contain" data-id="element-545" />
          </div>
        </div>
      </section>

      <section className="w-full text-white py-16 px-6 md:px-12 lg:px-20" style={{
      backgroundColor: '#545454'
    }} data-id="element-546">
        <div className="max-w-6xl mx-auto" data-id="element-547">
          <h2 className="text-3xl text-orange-500 font-light mb-8" data-id="element-548">
            Mentale Gesundheit
          </h2>

          <h3 className="text-2xl font-light mb-8" data-id="element-549">
            Mentale Gesundheit als Erfolgsfaktor – für Menschen und
            Organisationen
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-550">
            <div className="space-y-6 text-base leading-relaxed" data-id="element-551">
              <p data-id="element-552">
                Wer dauerhaft viel leisten will, braucht mentale Stärke – und
                ein Arbeitsumfeld, das sie schützt. Denn mentale Gesundheit ist
                eine der Grundvoraussetzungen für Leistungsfähigkeit und
                Spitzenleistung.
              </p>

              <p data-id="element-553">
                In der Realität sieht das häufig anders aus: Hohe Erwartungen,
                wenig Raum für persönliche Themen, viele unausgesprochene
                Spannungen im Team. Zwischen den Zeilen lautet die Botschaft
                oft: Hauptsache die Zahlen stimmen.
              </p>

              <p data-id="element-554">
                Doch was wäre, wenn wir ungenutztes individuelles Potenziale und
                Ressourcen, die ein Team leistungsfähig halten erschließen – und
                Sie, ihr Team oder ihre Organisation resilienter und
                zukunftsfähiger machen?
              </p>

              <p className="italic border-l-4 border-orange-500 pl-4" data-id="element-555">
                „Du kannst nicht für andere da sein, wenn du nicht zuerst für
                dich selbst da bist."
                <br data-id="element-556" />
                <span className="text-sm" data-id="element-557">– Brené Brown</span>
              </p>

              <h3 className="text-xl font-semibold pt-4" data-id="element-558">
                Mentale Gesundheit ist kein Soft Skill – sondern ein echter
                Wettbewerbsvorteil
              </h3>

              <p data-id="element-559">
                Gesunde, psychisch stabile Mitarbeitende treffen bessere
                Entscheidungen, kommunizieren klarer, sind belastbarer – und
                tragen aktiv zu einer positiven, wirkungsvollen
                Unternehmenskultur bei.
              </p>

              <h3 className="text-xl font-semibold pt-4" data-id="element-560">Kontakt</h3>
              <p data-id="element-561">
                Ob Sie als Führungskraft neue Impulse suchen, eine Krise
                bewältigen möchten oder Mental Health strategisch in Ihrer
                Organisation verankern wollen – ich unterstütze Sie mit
                psychologischer Expertise, wirtschaftlicher Erfahrung und klarem
                Blick für das Machbare.
              </p>
              <p data-id="element-562">Lassen Sie uns darüber sprechen und nehmen Sie Kontakt auf!</p>

              <div className="pt-2" data-id="element-563">
                <a href="/kontakt" className="inline-block bg-orange-500 hover:bg-orange-600 text-white px-8 py-3 transition-colors" data-id="element-564">
                  Lassen Sie uns sprechen
                </a>
              </div>
            </div>

            <div className="space-y-6 text-base leading-relaxed" data-id="element-565">
              <h3 className="text-xl font-semibold" data-id="element-566">Mein Angebot:</h3>

              <div className="bg-white bg-opacity-10 p-6 rounded" data-id="element-567">
                <h4 className="font-semibold mb-3" data-id="element-568">
                  Impulsvorträge & Keynotes
                </h4>
                <p className="mb-3" data-id="element-569">
                  Kompakt, fundiert und wirkungsvoll. In meinen Vorträgen
                  vermittle ich psychologisches Know-how praxisnah und auf den
                  Punkt – zu Themen wie:
                </p>
                <ul className="space-y-2 ml-4" data-id="element-570">
                  <li className="flex items-start" data-id="element-571">
                    <span className="mr-3 mt-1.5 w-1.5 h-1.5 bg-white rounded-full flex-shrink-0" data-id="element-572"></span>
                    <span data-id="element-573">Mentale Gesundheit am Arbeitsplatz</span>
                  </li>
                  <li className="flex items-start" data-id="element-574">
                    <span className="mr-3 mt-1.5 w-1.5 h-1.5 bg-white rounded-full flex-shrink-0" data-id="element-575"></span>
                    <span data-id="element-576">Gesunde Führung</span>
                  </li>
                  <li className="flex items-start" data-id="element-577">
                    <span className="mr-3 mt-1.5 w-1.5 h-1.5 bg-white rounded-full flex-shrink-0" data-id="element-578"></span>
                    <span data-id="element-579">Mentale Stärke & Selbstfürsorge</span>
                  </li>
                </ul>
                <p className="mt-3 text-sm" data-id="element-580">
                  Ideal für Teamtage, Führungskräfteveranstaltungen oder interne
                  Lernformate.
                </p>
              </div>

              <div className="bg-white bg-opacity-10 p-6 rounded" data-id="element-581">
                <h4 className="font-semibold mb-3" data-id="element-582">Workshops & Trainings</h4>
                <p className="mb-3" data-id="element-583">
                  Ich unterstütze Teams und Organisationen mit praxisnahen
                  Workshops und Trainings zu folgenden Themen:
                </p>
                <ul className="space-y-2 ml-4" data-id="element-584">
                  <li className="flex items-start" data-id="element-585">
                    <span className="mr-3 mt-1.5 w-1.5 h-1.5 bg-white rounded-full flex-shrink-0" data-id="element-586"></span>
                    <span data-id="element-587">Resilienz und Stressmanagement</span>
                  </li>
                  <li className="flex items-start" data-id="element-588">
                    <span className="mr-3 mt-1.5 w-1.5 h-1.5 bg-white rounded-full flex-shrink-0" data-id="element-589"></span>
                    <span data-id="element-590">Mentale Gesundheit im Arbeitsalltag</span>
                  </li>
                  <li className="flex items-start" data-id="element-591">
                    <span className="mr-3 mt-1.5 w-1.5 h-1.5 bg-white rounded-full flex-shrink-0" data-id="element-592"></span>
                    <span data-id="element-593">Gesunde Führung</span>
                  </li>
                  <li className="flex items-start" data-id="element-594">
                    <span className="mr-3 mt-1.5 w-1.5 h-1.5 bg-white rounded-full flex-shrink-0" data-id="element-595"></span>
                    <span data-id="element-596">Konstruktive Kommunikation und Konfliktklärung</span>
                  </li>
                </ul>
              </div>

              <div className="bg-white bg-opacity-10 p-6 rounded" data-id="element-597">
                <h4 className="font-semibold mb-3" data-id="element-598">
                  Krisenbegleitung und Prävention
                </h4>
                <p className="mb-3" data-id="element-599">
                  Psychische Belastungen gehören zum Berufsalltag – doch oft
                  werden sie zu spät erkannt, tabuisiert und nicht ernst
                  genommen. Dabei ist es möglich, erste Warnzeichen früh
                  wahrzunehmen, Dynamiken besser zu verstehen und gezielt
                  gegenzusteuern.
                </p>
                <p className="mb-3" data-id="element-600">
                  Ich unterstütze Unternehmen, Führungskräfte und Mitarbeitende
                  dabei:
                </p>
                <ul className="space-y-2 ml-4" data-id="element-601">
                  <li className="flex items-start" data-id="element-602">
                    <span className="mr-3 mt-1.5 w-1.5 h-1.5 bg-white rounded-full flex-shrink-0" data-id="element-603"></span>
                    <span data-id="element-604">
                      psychische Belastung am Arbeitsplatz zu erkennen,
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-605">
                    <span className="mr-3 mt-1.5 w-1.5 h-1.5 bg-white rounded-full flex-shrink-0" data-id="element-606"></span>
                    <span data-id="element-607">offen und lösungsorientiert damit umzugehen,</span>
                  </li>
                  <li className="flex items-start" data-id="element-608">
                    <span className="mr-3 mt-1.5 w-1.5 h-1.5 bg-white rounded-full flex-shrink-0" data-id="element-609"></span>
                    <span data-id="element-610">
                      präventive Maßnahmen zu entwickeln, die Gesundheit,
                      Stabilität und Leistungsfähigkeit erhalten.
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>;
};